import { usePricingQuery } from '@xver/hooks/usePricingQuery';

import { resolveVolumeRate } from '../../ContainerEngineInstancePage/utils/volumeCost';

/**
 * THB per decimal GB-month for Block storage. Volumes are sized in GiB, so price them with
 * `volumeMonthlyCost(sizeGiB, rate)` (GiB x 1.073741824 x rate), the same math as container
 * volumes; hourly is monthly / 730.
 */
export function useBlockStorageRate(): number {
    const { data } = usePricingQuery();
    return resolveVolumeRate(data?.products.block_storage?.gb_monthly_rate);
}
